import { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import plusFill from "@iconify/icons-eva/plus-fill";
import editFill from "@iconify/icons-eva/edit-2-fill";
import iconDelete from "@iconify/icons-eva/person-delete-fill";
import moment from "moment";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { Card, Table, Stack, Avatar, Button, TableRow, TableBody, TableCell, Container, Typography, TableContainer, Switch } from "@mui/material";
import Page from "../../components/Page";
import Label from "../../components/Label";
import Scrollbar from "../../components/Scrollbar";
import SearchNotFound from "../../components/SearchNotFound";

import axios from "axios";
import MoreMenu from "src/components/common/MoreMenu";
import MyPagination from "src/components/common/MyPagination";
import ListHead from "src/components/common/ListHead";
import { BASE_URL, IMG_BASE_URL } from "src/config/constants";
import Confirm from "src/components/common/ConfirmDialog";
import ListToolbar from "src/components/common/ListToolbar";
import CellImage from "src/components/common/CellImage";
import { useDispatch } from "react-redux";
import { setLightBox } from "src/store/reducers/globalData";
import { asyncRequest } from "src/services/network";
import { alert } from "src/services/alert";
import UserInfo from "src/components/common/UserInfo";
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: "uid", label: "用户", alignRight: false },
  { id: "realname", label: "真实姓名", alignRight: false },
  { id: "mobile", label: "手机号", alignRight: false },
  { id: "cardId", label: "身份证号", alignRight: false },
  { id: "frongImg", label: "身份证正面", alignRight: false },
  { id: "cardBack", label: "身份证反面", alignRight: false },
  { id: "status", label: "状态", alignRight: false },
  { id: "createdAt", label: "申请时间", alignRight: false },
  { id: "" },
];

const moreMenus = [
  { title: "通过", icon: editFill },
  // { title: "删除", icon: iconDelete },
];

export default function UserAuth() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
  });

  useEffect(() => {
    getItems();
  }, [filter]);

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "user/auth/list",
      data: filter
    });
    setItems(data);
    setTotal(count);
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleMoreClick = (type, row) => {
    if (type === "通过") {
      // navigate(`/post/edit/${row.id}`, { state: row });
      handleAuth(row);
    }
  };

  async function handleAuth({ id, status }) {
    if (status == 1) return;

    Confirm({
      message: "确定通过实名认证吗?",
      async onConfirm() {
        const { data } = await asyncRequest({
          path: "/user/auth",
          data: { id, status: 1 },
        });

        const item = items.find((it) => it.id == id);
        item.status = 1;
        setItems([...items]);
      },
    });
  }


  const isUserNotFound = items.length === 0;

  return (
    <Page title="实名认证列表">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            实名认证列表
          </Typography>

          {/* <Button
            variant="contained"
            component={RouterLink}
            to="/post/add"
            startIcon={<Icon icon={plusFill} />}
          >
            添加财圈
          </Button> */}
        </Stack>

        <Card>
          <ListToolbar
            numSelected={selected.length}
            filterName={filter.search}
            onFilterName={(e) => {
              setFilter({
                ...filter,
                search: e.target.value,
              });
            }}
            onRefresh={getItems}
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} />
                <TableBody>
                  {items.map((row) => {
                    const { id, uid, realname, user, mobile, cardId, status, cardFront, cardBack, license, createdAt } = row;
                    const isItemSelected = selected.indexOf(mobile) !== -1;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={isItemSelected} aria-checked={isItemSelected}>
                        {/* <TableCell padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              onChange={(event) => handleClick(event, uid)}
                            />
                          </TableCell> */}
                        <TableCell component="th" scope="row" padding="none" sx={{ pl: 1 }}>
                          <UserInfo {...user} />
                          {/* <Stack direction="row" alignItems="center" spacing={2}>
                            <Avatar alt={user.nickname} src={user.avatar} />
                            <Typography variant="subtitle2" noWrap>
                              {user.nickname || uid}
                            </Typography>
                          </Stack> */}
                        </TableCell>
                        <TableCell align="left">{realname}</TableCell>
                        <TableCell align="left">{mobile}</TableCell>
                        <TableCell align="left">{cardId}</TableCell>
                        <TableCell align="left">
                          <CellImage src={cardFront} preview />
                        </TableCell>
                        <TableCell align="left">
                          <CellImage src={cardBack} preview />
                        </TableCell>
                        <TableCell align="left">
                          <Label color={["warning", "success"][status]}>{["待审核", "已通过"][status]}</Label>
                        </TableCell>
                        <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>
                        <TableCell align="right">
                          <MoreMenu spread menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filter.search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
        </Card>
      </Container>
    </Page>
  );
}
